/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type AccountSummary = {
  __typename?: 'AccountSummary';
  hasAppointments?: Maybe<Scalars['Boolean']>;
  hasOrders?: Maybe<Scalars['Boolean']>;
  hasReferralCode?: Maybe<Scalars['Boolean']>;
  isLoggedIn?: Maybe<Scalars['Boolean']>;
};

export type Appointment = {
  __typename?: 'Appointment';
  appointmentCustomer?: Maybe<AppointmentCustomer>;
  appointmentTime?: Maybe<AppointmentTime>;
  campaignDate?: Maybe<CampaignDate>;
  campaignEvent?: Maybe<CampaignEvent>;
  confirmationNumber?: Maybe<Scalars['String']>;
  event?: Maybe<AppointmentEvent>;
  frozen?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Location>;
  status?: Maybe<Scalars['String']>;
};

export type AppointmentCampaignDate = {
  __typename?: 'AppointmentCampaignDate';
  eventDate?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
};

export type AppointmentCustomer = {
  __typename?: 'AppointmentCustomer';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  guests?: Maybe<Array<Maybe<Guest>>>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferredContact?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type AppointmentCustomerInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  guests?: InputMaybe<Array<InputMaybe<GuestInput>>>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  preferredContact?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type AppointmentEvent = {
  __typename?: 'AppointmentEvent';
  eventName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  urlPath?: Maybe<Scalars['String']>;
};

export type AppointmentExtensionInput = {
  driverLicenseBack?: InputMaybe<DriverLicenseInput>;
  driverLicenseFront?: InputMaybe<DriverLicenseInput>;
};

export type AppointmentTime = {
  __typename?: 'AppointmentTime';
  available?: Maybe<Scalars['Boolean']>;
  endTime?: Maybe<Scalars['String']>;
  frozen?: Maybe<Scalars['Boolean']>;
  full?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['String']>;
};

export type BaseEvent = {
  __typename?: 'BaseEvent';
  campaign?: Maybe<Campaign>;
  campaignEvents?: Maybe<Array<Maybe<CEvent>>>;
  event?: Maybe<EventName>;
  eventName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invitationCodeRequired?: Maybe<Scalars['Boolean']>;
  urlPath?: Maybe<Scalars['String']>;
};

export type CEvent = {
  __typename?: 'CEvent';
  endDate?: Maybe<Scalars['String']>;
  eventTimes?: Maybe<Array<Maybe<EventTime>>>;
  guestCapacity?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  intervalCapacity?: Maybe<Scalars['Int']>;
  intervalInMinutes?: Maybe<Scalars['Int']>;
  location?: Maybe<Location>;
  sessionFreezeHour?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['String']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  campaignName?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  eventCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type CampaignDate = {
  __typename?: 'CampaignDate';
  appointmentTimes?: Maybe<Array<Maybe<AppointmentTime>>>;
  eventDate?: Maybe<Scalars['String']>;
};

export type CampaignEvent = {
  __typename?: 'CampaignEvent';
  id?: Maybe<Scalars['Int']>;
};

export type Configuration = {
  __typename?: 'Configuration';
  configuratorOptions?: Maybe<Array<Maybe<ConfiguratorOption>>>;
  configuratorRefURL?: Maybe<Scalars['String']>;
  confirmationNum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  editionCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  modelCode?: Maybe<Scalars['String']>;
  vehicleConfigurationAssets?: Maybe<VehicleConfigurationAssets>;
  version?: Maybe<Scalars['Int']>;
};

export type ConfigurationConfirmation = {
  __typename?: 'ConfigurationConfirmation';
  _id?: Maybe<Scalars['String']>;
  confirmationNum?: Maybe<Scalars['String']>;
};

export type ConfigurationInput = {
  orderNum?: InputMaybe<Scalars['String']>;
  overwrite?: InputMaybe<Scalars['Boolean']>;
  vehicleModelId?: InputMaybe<Scalars['Int']>;
  vehicleOptionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ConfigurationSummaryResponse = {
  __typename?: 'ConfigurationSummaryResponse';
  basePrice?: Maybe<Scalars['Float']>;
  dueAmount?: Maybe<Scalars['Float']>;
  preorderBalance?: Maybe<Scalars['Float']>;
  preorderDepositAmount?: Maybe<Scalars['Float']>;
  preorderPaidAmount?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  vehicleModel?: Maybe<VehicleModel>;
  vehicleOptions?: Maybe<Array<Maybe<VehicleOption>>>;
};

export type ConfiguratorInput = {
  email?: InputMaybe<Scalars['String']>;
  gaCookies?: InputMaybe<Scalars['String']>;
  orderDetail?: InputMaybe<OrderDetailInput>;
};

export type ConfiguratorOption = {
  __typename?: 'ConfiguratorOption';
  category?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  option?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ConfiguratorOrderInput = {
  customerForm?: InputMaybe<CustomerFormInput>;
  financeForm?: InputMaybe<FinanceFormInput>;
  gaCookies?: InputMaybe<Scalars['String']>;
  orderDetail?: InputMaybe<OrderDetailInput>;
};

export type Confirmation = {
  __typename?: 'Confirmation';
  success?: Maybe<Scalars['Boolean']>;
};

export type ConvertPreorderConfirmation = {
  __typename?: 'ConvertPreorderConfirmation';
  _id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  orderNum?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ConvertPreorderInput = {
  isOnWaitlist?: InputMaybe<Scalars['Boolean']>;
  orderNum?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<PaymentInput>;
  referralCode?: InputMaybe<Scalars['String']>;
  vehicleConfiguration?: InputMaybe<OrderConfigurationInput>;
};

export type CoverImage = {
  __typename?: 'CoverImage';
  desktop?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  tablet?: Maybe<Scalars['String']>;
};

export type CreateOrderConfirmation = {
  __typename?: 'CreateOrderConfirmation';
  _id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  orderNum?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateOrderInput = {
  isOnWaitlist?: InputMaybe<Scalars['Boolean']>;
  orderType?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<PaymentInput>;
  referralCode?: InputMaybe<Scalars['String']>;
  vehicleConfiguration?: InputMaybe<OrderConfigurationInput>;
  vehicleConfigurationId?: InputMaybe<Scalars['Int']>;
};

export type Credential = {
  __typename?: 'Credential';
  access_token?: Maybe<Scalars['String']>;
  cmd_token?: Maybe<Scalars['String']>;
  expires_in?: Maybe<Scalars['Float']>;
  jti?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

export type CustomerReward = {
  __typename?: 'CustomerReward';
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  referralCode?: Maybe<Scalars['String']>;
  rewardPayoutAmount?: Maybe<Scalars['Float']>;
  rewardPayoutAt?: Maybe<Scalars['String']>;
  rewardPayoutPoints?: Maybe<Scalars['Float']>;
  rewardType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type DeleteAccountInput = {
  reason?: InputMaybe<Scalars['String']>;
};

export type DeleteAccountResponse = {
  __typename?: 'DeleteAccountResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DriverLicenseInput = {
  base64?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
};

export type Email = {
  __typename?: 'Email';
  _id?: Maybe<Scalars['String']>;
  didExist?: Maybe<Scalars['Boolean']>;
};

export type Event = {
  __typename?: 'Event';
  campaignDates?: Maybe<Array<Maybe<CampaignDate>>>;
  event?: Maybe<EventName>;
  eventName?: Maybe<Scalars['String']>;
  guestCapacity?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Location>;
};

export type EventName = {
  __typename?: 'EventName';
  eventName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type EventTime = {
  __typename?: 'EventTime';
  endTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type FpoRegistrationInput = {
  addressCode?: InputMaybe<Scalars['String']>;
  currentMakeModel?: InputMaybe<Scalars['String']>;
  drivingStatus?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hasReservation?: InputMaybe<Scalars['Boolean']>;
  interests?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastName?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
};

export type FpoRegistrationV2Input = {
  survey?: InputMaybe<Array<InputMaybe<FpoSurveyAnswer>>>;
};

export type Finance = {
  __typename?: 'Finance';
  annualAPR?: Maybe<Scalars['String']>;
  downPayment?: Maybe<Scalars['String']>;
  estLoanPayment?: Maybe<Scalars['String']>;
  preferredPaymentMethod?: Maybe<Scalars['String']>;
  preferredPaymentMethodId?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
};

export type FpoSurvey = {
  __typename?: 'FpoSurvey';
  active?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<FpoSurveyOption>>>;
  syncFieldName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type FpoSurveyAnswer = {
  answer?: InputMaybe<Scalars['String']>;
  optionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  questionId?: InputMaybe<Scalars['Int']>;
};

export type FpoSurveyOption = {
  __typename?: 'FpoSurveyOption';
  active?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Guest = {
  __typename?: 'Guest';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
};

export type GuestInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type InvitationCode = {
  __typename?: 'InvitationCode';
  expirationDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invitationCode?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Boolean']>;
  usedDate?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locationCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type MakeAppointmentConfirmation = {
  __typename?: 'MakeAppointmentConfirmation';
  confirmationNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type MakeAppointmentInput = {
  appointmentCustomer?: InputMaybe<AppointmentCustomerInput>;
  appointmentTimeId?: InputMaybe<Scalars['Int']>;
  invitationCode?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelAppointment?: Maybe<Confirmation>;
  changePassword?: Maybe<User>;
  convertPreorder?: Maybe<ConvertPreorderConfirmation>;
  createOrder?: Maybe<CreateOrderConfirmation>;
  deleteAccount?: Maybe<DeleteAccountResponse>;
  deleteConfiguration?: Maybe<SuccessResponse>;
  forgotPassword?: Maybe<Scalars['Boolean']>;
  fpoRegistration?: Maybe<Scalars['Boolean']>;
  fpoRegistrationV2?: Maybe<Scalars['Boolean']>;
  isUserExist?: Maybe<Scalars['Boolean']>;
  joinOrderWaitlist?: Maybe<Scalars['Boolean']>;
  joinWaitlist?: Maybe<Confirmation>;
  login?: Maybe<User>;
  logout?: Maybe<User>;
  makeAppointment?: Maybe<MakeAppointmentConfirmation>;
  makeBooking?: Maybe<OrderConfirmation>;
  /** @deprecated Use saveConfiguration instead */
  makeConfiguration?: Maybe<ConfigurationConfirmation>;
  makeReservation?: Maybe<OrderConfirmation>;
  orderConfirmationSalesAgreement?: Maybe<SuccessResponse>;
  placeOrder?: Maybe<ConfigurationConfirmation>;
  productionConfirmation?: Maybe<SuccessResponse>;
  register?: Maybe<User>;
  rescheduleAppointment?: Maybe<RescheduleAppointmentConfirmation>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  saveConfiguration?: Maybe<SaveConfigurationResponse>;
  saveOrderDelivery?: Maybe<OrderDeliveryResponse>;
  saveSingleConfiguration?: Maybe<SaveSingleConfigurationResponse>;
  saveVehicleRegistration?: Maybe<SuccessResponse>;
  sendEmailCode?: Maybe<SendEmailCodeResponse>;
  signupEvent?: Maybe<Scalars['Boolean']>;
  subscribeFF91?: Maybe<SuccessResponse>;
  updateProfile?: Maybe<User>;
  validateInvitationCode?: Maybe<ValidateInvitationCodeConfirmation>;
  validateReferralCode?: Maybe<ValidateReferralCode>;
};


export type MutationCancelAppointmentArgs = {
  appointmentId: Scalars['Int'];
};


export type MutationChangePasswordArgs = {
  oldPassword: Scalars['String'];
  password: Scalars['String'];
};


export type MutationConvertPreorderArgs = {
  preorder: ConvertPreorderInput;
};


export type MutationCreateOrderArgs = {
  order: CreateOrderInput;
};


export type MutationDeleteAccountArgs = {
  deleteAccountForm: DeleteAccountInput;
};


export type MutationDeleteConfigurationArgs = {
  configurationId: Scalars['Int'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationFpoRegistrationArgs = {
  fpoForm: FpoRegistrationInput;
};


export type MutationFpoRegistrationV2Args = {
  fpoRegistration: FpoRegistrationV2Input;
};


export type MutationIsUserExistArgs = {
  email: Scalars['String'];
};


export type MutationJoinOrderWaitlistArgs = {
  confirmationNum: Scalars['String'];
};


export type MutationJoinWaitlistArgs = {
  campaignEventId: Scalars['Int'];
  invitationCode?: InputMaybe<Scalars['String']>;
  preferredContact: Scalars['String'];
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  gaCookies: Scalars['String'];
  password: Scalars['String'];
};


export type MutationMakeAppointmentArgs = {
  appointment: MakeAppointmentInput;
  extension?: InputMaybe<AppointmentExtensionInput>;
};


export type MutationMakeBookingArgs = {
  bookingForm: BookingFormInput;
};


export type MutationMakeConfigurationArgs = {
  configuration: ConfiguratorInput;
};


export type MutationMakeReservationArgs = {
  paymentForm: PaymentFormInput;
  profileForm: ProfileFormInput;
};


export type MutationOrderConfirmationSalesAgreementArgs = {
  orderConfirmationSalesAgreement: OrderConfirmationSalesAgreementInput;
};


export type MutationPlaceOrderArgs = {
  configuratorOrder?: InputMaybe<ConfiguratorOrderInput>;
};


export type MutationProductionConfirmationArgs = {
  form: ProductionConfirmationFormInput;
};


export type MutationRegisterArgs = {
  registerForm: RegisterFormInput;
};


export type MutationRescheduleAppointmentArgs = {
  appointment: RescheduleAppointmentInput;
};


export type MutationResetPasswordArgs = {
  key: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationSaveConfigurationArgs = {
  configuration: ConfigurationInput;
};


export type MutationSaveOrderDeliveryArgs = {
  form: OrderDeliveryFormInput;
};


export type MutationSaveSingleConfigurationArgs = {
  configuration: ConfigurationInput;
};


export type MutationSaveVehicleRegistrationArgs = {
  form: VehicleRegistrationFormInput;
};


export type MutationSendEmailCodeArgs = {
  email: Scalars['String'];
};


export type MutationSignupEventArgs = {
  interestedEvent: Scalars['String'];
};


export type MutationSubscribeFf91Args = {
  subscribeFF91Form?: InputMaybe<SubscribeFf91Input>;
};


export type MutationUpdateProfileArgs = {
  profileForm: ProfileFormInput;
};


export type MutationValidateInvitationCodeArgs = {
  eventId: Scalars['Int'];
  invitationCode: Scalars['String'];
};


export type MutationValidateReferralCodeArgs = {
  referralCode: Scalars['String'];
};

export type Order = {
  __typename?: 'Order';
  _id?: Maybe<Scalars['String']>;
  confirmationNum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  customerRewards?: Maybe<Array<Maybe<CustomerReward>>>;
  depositAmount?: Maybe<Scalars['String']>;
  isConvertedFromPreorder?: Maybe<Scalars['Boolean']>;
  isOnWaitlist?: Maybe<Scalars['Boolean']>;
  orderDelivery?: Maybe<OrderDelivery>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  orderNum?: Maybe<Scalars['String']>;
  orderPaymentCores?: Maybe<Array<Maybe<OrderPayment>>>;
  orderStatus?: Maybe<OrderStatus>;
  preorderConvertedAt?: Maybe<Scalars['String']>;
  preorderDepositAmount?: Maybe<Scalars['String']>;
  priorityType?: Maybe<Scalars['String']>;
  reward?: Maybe<Array<Maybe<Reward>>>;
  rewardValue?: Maybe<Scalars['String']>;
  statusDesc?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['String']>;
  trackingStatus?: Maybe<Scalars['String']>;
  typeDesc?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  vehicle?: Maybe<Vehicle>;
  vehicleConfigurationCore?: Maybe<VehicleConfiguration>;
  vehicleModel?: Maybe<VehicleModel>;
  vehicleRegistration?: Maybe<VehicleRegistration>;
  waitlist?: Maybe<Scalars['Boolean']>;
  waitlistJoinedAt?: Maybe<Scalars['String']>;
};

export type OrderConfigurationInput = {
  modelId?: InputMaybe<Scalars['Int']>;
  optionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type OrderConfirmation = {
  __typename?: 'OrderConfirmation';
  _id?: Maybe<Scalars['String']>;
  confirmationNum?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type OrderConfirmationSalesAgreementInput = {
  orderNum: Scalars['String'];
};

export type OrderDelivery = {
  __typename?: 'OrderDelivery';
  deliveryAddress1?: Maybe<Scalars['String']>;
  deliveryAddress2?: Maybe<Scalars['String']>;
  deliveryCity?: Maybe<Scalars['String']>;
  deliveryStateOrProvince?: Maybe<Scalars['String']>;
  deliveryZipcode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type OrderDeliveryFormInput = {
  deliveryAddress1: Scalars['String'];
  deliveryAddress2?: InputMaybe<Scalars['String']>;
  deliveryCity: Scalars['String'];
  deliveryStateOrProvince: Scalars['String'];
  deliveryZipcode: Scalars['String'];
  orderNum: Scalars['String'];
};

export type OrderDeliveryResponse = {
  __typename?: 'OrderDeliveryResponse';
  deliveryAddress1?: Maybe<Scalars['String']>;
  deliveryAddress2?: Maybe<Scalars['String']>;
  deliveryCity?: Maybe<Scalars['String']>;
  deliveryStateOrProvince?: Maybe<Scalars['String']>;
  deliveryZipcode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type OrderDetails = {
  __typename?: 'OrderDetails';
  _id?: Maybe<Scalars['String']>;
  billingAddress1?: Maybe<Scalars['String']>;
  billingAddress2?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingFirstName?: Maybe<Scalars['String']>;
  billingLastName?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  billingZip?: Maybe<Scalars['String']>;
  canDowngradeEdition?: Maybe<Scalars['Boolean']>;
  canUpgradeEdition?: Maybe<Scalars['Boolean']>;
  confirmationNum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customerRewards?: Maybe<Array<Maybe<CustomerReward>>>;
  depositAmount?: Maybe<Scalars['String']>;
  depositRefundExpirationDate?: Maybe<Scalars['String']>;
  description?: Maybe<Array<Maybe<Scalars['String']>>>;
  finance?: Maybe<Finance>;
  isConvertedFromPreorder?: Maybe<Scalars['Boolean']>;
  isOnWaitlist?: Maybe<Scalars['Boolean']>;
  orderDelivery?: Maybe<OrderDelivery>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  orderNum?: Maybe<Scalars['String']>;
  orderPaymentCores?: Maybe<Array<Maybe<OrderPayment>>>;
  orderStatus?: Maybe<OrderStatus>;
  paidAmount?: Maybe<Scalars['Float']>;
  payment?: Maybe<PaymentDetails>;
  preorderConvertedAt?: Maybe<Scalars['String']>;
  preorderDepositAmount?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  priorityType?: Maybe<Scalars['String']>;
  reservationHolder?: Maybe<ReservationHolder>;
  reward?: Maybe<Array<Maybe<Reward>>>;
  rewardValue?: Maybe<Scalars['String']>;
  statusDesc?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['String']>;
  trackingStatus?: Maybe<Scalars['String']>;
  typeDesc?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  vehicle?: Maybe<Vehicle>;
  vehicleConfigurationAssets?: Maybe<VehicleConfigurationAssets>;
  vehicleConfigurationCore?: Maybe<VehicleConfiguration>;
  vehicleModel?: Maybe<VehicleModel>;
  vehicleRegistration?: Maybe<VehicleRegistration>;
  waitlist?: Maybe<Scalars['Boolean']>;
  waitlistJoinedAt?: Maybe<Scalars['String']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  orderItemType?: Maybe<OrderItemType>;
  orderItemTypeDesc?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type OrderItemType = {
  __typename?: 'OrderItemType';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type OrderPayment = {
  __typename?: 'OrderPayment';
  billingAddress1?: Maybe<Scalars['String']>;
  billingAddress2?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingFirstName?: Maybe<Scalars['String']>;
  billingLastName?: Maybe<Scalars['String']>;
  billingStateOrProvince?: Maybe<Scalars['String']>;
  billingZipcode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  cyberSourceRequestId?: Maybe<Scalars['String']>;
  details?: Maybe<OrderPaymentDetails>;
  id?: Maybe<Scalars['Int']>;
  orderPaymentItems?: Maybe<Array<Maybe<OrderPaymentItem>>>;
  paymentMethod?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type OrderPaymentDetails = {
  __typename?: 'OrderPaymentDetails';
  cardExpirationMonth?: Maybe<Scalars['String']>;
  cardExpirationYear?: Maybe<Scalars['String']>;
  cardSuffix?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
};

export type OrderPaymentItem = {
  __typename?: 'OrderPaymentItem';
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  paidAmount?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type OrderStatus = {
  __typename?: 'OrderStatus';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  cardExpirationMonth?: Maybe<Scalars['String']>;
  cardExpirationYear?: Maybe<Scalars['String']>;
  cardSuffix?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
};

export type PaymentInput = {
  billingAddress1?: InputMaybe<Scalars['String']>;
  billingAddress2?: InputMaybe<Scalars['String']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingFirstName?: InputMaybe<Scalars['String']>;
  billingLastName?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  billingZipcode?: InputMaybe<Scalars['String']>;
  creditCardExpMonth?: InputMaybe<Scalars['String']>;
  creditCardExpYear?: InputMaybe<Scalars['String']>;
  creditCardNum?: InputMaybe<Scalars['String']>;
  cvv?: InputMaybe<Scalars['String']>;
};

export type ProductionConfirmationFormInput = {
  orderNum: Scalars['String'];
  payment: PaymentInput;
};

export type Query = {
  __typename?: 'Query';
  /** @deprecated Feature no longer required */
  accountSummary?: Maybe<AccountSummary>;
  appointment?: Maybe<Appointment>;
  appointments?: Maybe<Array<Maybe<Appointment>>>;
  baseEvent?: Maybe<BaseEvent>;
  configurationSummary?: Maybe<ConfigurationSummaryResponse>;
  configurations?: Maybe<Array<Maybe<Configuration>>>;
  event?: Maybe<Event>;
  fpoSurvey?: Maybe<Array<Maybe<FpoSurvey>>>;
  orderDetails?: Maybe<OrderDetails>;
  orders?: Maybe<Array<Maybe<Order>>>;
  referralCode?: Maybe<Scalars['String']>;
  referralReward?: Maybe<ReferralReward>;
  referrals?: Maybe<Referral>;
  referrer?: Maybe<Referrer>;
  rewards?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  vehicleModelDetails?: Maybe<VehicleModelDetails>;
  vehicleModels?: Maybe<Array<Maybe<VehicleModel>>>;
  vehicleOptions?: Maybe<Array<Maybe<VehicleOption>>>;
  verifyEmail?: Maybe<Email>;
};


export type QueryAppointmentArgs = {
  id: Scalars['Int'];
};


export type QueryBaseEventArgs = {
  eventName: Scalars['String'];
};


export type QueryConfigurationSummaryArgs = {
  configurationInput: ConfigurationInput;
};


export type QueryConfigurationsArgs = {
  confirmationNum?: InputMaybe<Scalars['String']>;
};


export type QueryEventArgs = {
  eventId: Scalars['Int'];
};


export type QueryOrderDetailsArgs = {
  confNum: Scalars['String'];
};


export type QueryOrdersArgs = {
  confNum?: InputMaybe<Scalars['String']>;
};


export type QueryReferrerArgs = {
  referralCode: Scalars['String'];
};


export type QueryVehicleModelDetailsArgs = {
  modelId: Scalars['Int'];
};


export type QueryVehicleOptionsArgs = {
  modelId: Scalars['Int'];
};


export type QueryVerifyEmailArgs = {
  email: Scalars['String'];
};

export type Referral = {
  __typename?: 'Referral';
  cancelled?: Maybe<ReferralNumber>;
  deduction?: Maybe<ReferralDeductions>;
  referee?: Maybe<ReferralNumber>;
  refereeNames?: Maybe<ReferralName>;
  referrer?: Maybe<ReferralNumber>;
  referrerNames?: Maybe<ReferralName>;
};

export type ReferralDeductions = {
  __typename?: 'ReferralDeductions';
  priorityFuturist?: Maybe<Scalars['Int']>;
  priorityProfessional?: Maybe<Scalars['Int']>;
  standard?: Maybe<Scalars['Int']>;
  totalReferral?: Maybe<Scalars['Int']>;
  totalSummary?: Maybe<Scalars['Int']>;
};

export type ReferralName = {
  __typename?: 'ReferralName';
  priorityFuturist?: Maybe<Array<Maybe<Scalars['String']>>>;
  priorityProfessional?: Maybe<Array<Maybe<Scalars['String']>>>;
  standard?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ReferralNumber = {
  __typename?: 'ReferralNumber';
  priorityFuturist?: Maybe<Scalars['Int']>;
  priorityProfessional?: Maybe<Scalars['Int']>;
  standard?: Maybe<Scalars['Int']>;
};

export type ReferralReward = {
  __typename?: 'ReferralReward';
  referralCode?: Maybe<Scalars['String']>;
  referrals?: Maybe<Array<Maybe<ReferralRewardItem>>>;
};

export type ReferralRewardItem = {
  __typename?: 'ReferralRewardItem';
  amount?: Maybe<Scalars['Int']>;
  cancelled?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  referee?: Maybe<Scalars['Int']>;
  referrer?: Maybe<Scalars['Int']>;
  rewardType?: Maybe<Scalars['String']>;
};

export type Referrer = {
  __typename?: 'Referrer';
  avatar?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type RegisterFormInput = {
  addressCode?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  gaCookies?: InputMaybe<Scalars['String']>;
  interestedEvent?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type RescheduleAppointmentConfirmation = {
  __typename?: 'RescheduleAppointmentConfirmation';
  success?: Maybe<Scalars['Boolean']>;
};

export type RescheduleAppointmentInput = {
  appointmentId?: InputMaybe<Scalars['Int']>;
  appointmentTimeId?: InputMaybe<Scalars['Int']>;
  guests?: InputMaybe<Array<InputMaybe<GuestInput>>>;
};

export type ReservationHolder = {
  __typename?: 'ReservationHolder';
  addressCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
};

export type Reward = {
  __typename?: 'Reward';
  createdAt?: Maybe<Scalars['String']>;
  rewardType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SaveConfigurationResponse = {
  __typename?: 'SaveConfigurationResponse';
  _id?: Maybe<Scalars['Int']>;
  confirmationNum?: Maybe<Scalars['String']>;
};

export type SaveSingleConfigurationResponse = {
  __typename?: 'SaveSingleConfigurationResponse';
  _id?: Maybe<Scalars['Int']>;
  confirmationNum?: Maybe<Scalars['String']>;
  overwriteRequired?: Maybe<Scalars['Boolean']>;
};

export type SendEmailCodeResponse = {
  __typename?: 'SendEmailCodeResponse';
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type SubscribeFf91Input = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  zipCode: Scalars['String'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type User = {
  __typename?: 'User';
  activated?: Maybe<Scalars['Boolean']>;
  addressCity?: Maybe<Scalars['String']>;
  addressCode?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  authorities?: Maybe<Array<Maybe<Scalars['String']>>>;
  avatar?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  confirmationKey?: Maybe<Scalars['String']>;
  credential?: Maybe<Credential>;
  email?: Maybe<Scalars['String']>;
  emailSubscription?: Maybe<Scalars['Boolean']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  fpoStatus?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  langKey?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  leId?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  mobileVerified?: Maybe<Scalars['Boolean']>;
  username?: Maybe<Scalars['String']>;
};

export type ValidateInvitationCodeConfirmation = {
  __typename?: 'ValidateInvitationCodeConfirmation';
  event?: Maybe<Event>;
  expirationDate?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Boolean']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type ValidateReferralCode = {
  __typename?: 'ValidateReferralCode';
  message?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  configuratorOptions?: Maybe<Array<Maybe<ConfiguratorOption>>>;
  configuratorRefURL?: Maybe<Scalars['String']>;
  confirmationNum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  destinationAndDocFee?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  editionCode?: Maybe<Scalars['String']>;
  estDelivery?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  modelCode?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  vehicleConfigurationAssets?: Maybe<VehicleConfigurationAssets>;
  version?: Maybe<Scalars['Int']>;
};

export type VehicleAssetsExterior = {
  __typename?: 'VehicleAssetsExterior';
  color?: Maybe<VehicleAssetsOption>;
};

export type VehicleAssetsInterior = {
  __typename?: 'VehicleAssetsInterior';
  color?: Maybe<VehicleAssetsOption>;
};

export type VehicleAssetsOption = {
  __typename?: 'VehicleAssetsOption';
  categoryCode: Scalars['String'];
  categoryName?: Maybe<Scalars['String']>;
  configuredOption?: Maybe<VehicleAssetsOptionItem>;
  features?: Maybe<Array<Maybe<VehicleSpec>>>;
  typeCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  typeValues?: Maybe<Array<Maybe<VehicleAssetsOptionItem>>>;
};

export type VehicleAssetsOptionItem = {
  __typename?: 'VehicleAssetsOptionItem';
  code?: Maybe<Scalars['String']>;
  exteriorImages?: Maybe<Array<Maybe<VehicleImage>>>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  tileImage?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type VehicleConfiguration = {
  __typename?: 'VehicleConfiguration';
  active?: Maybe<Scalars['Boolean']>;
  configurationNum?: Maybe<Scalars['String']>;
  configuratorRefUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  vehicleConfigurationItems?: Maybe<Array<Maybe<VehicleConfigurationItem>>>;
  vehicleModel?: Maybe<VehicleModel>;
  vinNum?: Maybe<Scalars['String']>;
};

export type VehicleConfigurationAssets = {
  __typename?: 'VehicleConfigurationAssets';
  expectAvailableDate?: Maybe<Scalars['String']>;
  exterior?: Maybe<VehicleAssetsExterior>;
  interior?: Maybe<VehicleAssetsInterior>;
  locale?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  wheel?: Maybe<VehicleAssetsOption>;
};

export type VehicleConfigurationItem = {
  __typename?: 'VehicleConfigurationItem';
  id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  vehicleOption?: Maybe<VehicleOption>;
};

export type VehicleImage = {
  __typename?: 'VehicleImage';
  code?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type VehicleModel = {
  __typename?: 'VehicleModel';
  active?: Maybe<Scalars['Boolean']>;
  assetPath?: Maybe<Scalars['String']>;
  basePrice?: Maybe<Scalars['Float']>;
  brand?: Maybe<Scalars['String']>;
  depositAmount?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['String']>;
  fullModelCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isWaitlistAllowed?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderFee?: Maybe<Scalars['Float']>;
  preorderDepositAmount?: Maybe<Scalars['Float']>;
  region?: Maybe<Scalars['String']>;
  reserveSpotCap?: Maybe<Scalars['Int']>;
  vehicleMarketStatusDesc?: Maybe<Scalars['String']>;
  vehicleOverviewAssets?: Maybe<VehicleOverviewAssets>;
  year?: Maybe<Scalars['String']>;
};

export type VehicleModelDetails = {
  __typename?: 'VehicleModelDetails';
  active?: Maybe<Scalars['Boolean']>;
  assetPath?: Maybe<Scalars['String']>;
  basePrice?: Maybe<Scalars['Float']>;
  brand?: Maybe<Scalars['String']>;
  depositAmount?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['String']>;
  fullModelCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isWaitlistAllowed?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderFee?: Maybe<Scalars['Float']>;
  preorderDepositAmount?: Maybe<Scalars['Float']>;
  region?: Maybe<Scalars['String']>;
  reserveSpotCap?: Maybe<Scalars['Int']>;
  vehicleConfigurationAssets?: Maybe<VehicleConfigurationAssets>;
  vehicleMarketStatusDesc?: Maybe<Scalars['String']>;
  vehicleOverviewAssets?: Maybe<VehicleOverviewAssets>;
  year?: Maybe<Scalars['String']>;
};

export type VehicleOption = {
  __typename?: 'VehicleOption';
  active?: Maybe<Scalars['Boolean']>;
  combinations?: Maybe<Array<Maybe<VehicleOptionCombination>>>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  estDeliveryRange?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Float']>;
  vehicleOptionType?: Maybe<VehicleOptionType>;
};

export type VehicleOptionCombination = {
  __typename?: 'VehicleOptionCombination';
  vehicleOptionId?: Maybe<Scalars['Int']>;
  vehicleOptionTypeCategoryCode?: Maybe<Scalars['String']>;
  vehicleOptionTypeId?: Maybe<Scalars['Int']>;
};

export type VehicleOptionType = {
  __typename?: 'VehicleOptionType';
  categoryCode?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  typeCode?: Maybe<Scalars['String']>;
  typeName?: Maybe<Scalars['String']>;
};

export type VehicleOverviewAssets = {
  __typename?: 'VehicleOverviewAssets';
  coverImage?: Maybe<CoverImage>;
  edition?: Maybe<Scalars['String']>;
  expectAvailableDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  overviewFeatures?: Maybe<Array<Maybe<VehicleSpec>>>;
  overviewSpecs?: Maybe<Array<Maybe<VehicleSpec>>>;
  title?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type VehicleRegistration = {
  __typename?: 'VehicleRegistration';
  id?: Maybe<Scalars['Int']>;
};

export type VehicleRegistrationFormInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  addressType: Scalars['String'];
  andOr?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  dateOfBirth?: InputMaybe<Scalars['String']>;
  dateOfBirth2?: InputMaybe<Scalars['String']>;
  driverLicenseBack?: InputMaybe<Scalars['String']>;
  driverLicenseBack2?: InputMaybe<Scalars['String']>;
  driverLicenseFront?: InputMaybe<Scalars['String']>;
  driverLicenseFront2?: InputMaybe<Scalars['String']>;
  driverLicenseNumber?: InputMaybe<Scalars['String']>;
  driverLicenseNumber2?: InputMaybe<Scalars['String']>;
  driverLicenseState?: InputMaybe<Scalars['String']>;
  driverLicenseState2?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName2?: InputMaybe<Scalars['String']>;
  insurance?: InputMaybe<Scalars['String']>;
  insurance2?: InputMaybe<Scalars['String']>;
  isRegistrant?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName2?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  middleName2?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumber2?: InputMaybe<Scalars['String']>;
  relationshipToBusiness?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  taxIdNumber?: InputMaybe<Scalars['String']>;
  twoPeople?: InputMaybe<Scalars['Boolean']>;
  vehicleConfigurationNumber: Scalars['String'];
  zipCode: Scalars['String'];
};

export type VehicleSpec = {
  __typename?: 'VehicleSpec';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type BookingFormInput = {
  gaCookies?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
};

export type CustomerFormInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  creditCardNumber?: InputMaybe<Scalars['String']>;
  cvv?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FinanceFormInput = {
  apr?: InputMaybe<Scalars['String']>;
  downPayment?: InputMaybe<Scalars['Int']>;
  estimatedPayment?: InputMaybe<Scalars['Int']>;
  financedAmount?: InputMaybe<Scalars['Int']>;
  msrp?: InputMaybe<Scalars['Int']>;
  paymentType?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['Int']>;
};

export type OrderDetailInput = {
  EXC?: InputMaybe<Scalars['String']>;
  INT?: InputMaybe<Scalars['String']>;
  PKG?: InputMaybe<Scalars['String']>;
  SET?: InputMaybe<Scalars['String']>;
  VEH?: InputMaybe<Scalars['String']>;
  WHL?: InputMaybe<Scalars['String']>;
};

export type PaymentFormInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  agreement?: InputMaybe<Scalars['Boolean']>;
  billingZIP?: InputMaybe<Scalars['String']>;
  card?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  cvv?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gaCookies?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  waitlist?: InputMaybe<Scalars['Boolean']>;
};

export type ProfileFormInput = {
  addressCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailSubscription?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
};

export type SaveSingleConfigurationMutationVariables = Exact<{
  configuration: ConfigurationInput;
}>;


export type SaveSingleConfigurationMutation = { __typename?: 'Mutation', saveSingleConfiguration?: { __typename?: 'SaveSingleConfigurationResponse', _id?: number | null, confirmationNum?: string | null, overwriteRequired?: boolean | null } | null };

export type SubscribeFf91MutationVariables = Exact<{
  form: SubscribeFf91Input;
}>;


export type SubscribeFf91Mutation = { __typename?: 'Mutation', subscribeFF91?: { __typename?: 'SuccessResponse', success?: boolean | null } | null };


export const SaveSingleConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveSingleConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"configuration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveSingleConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"configuration"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationNum"}},{"kind":"Field","name":{"kind":"Name","value":"overwriteRequired"}}]}}]}}]} as unknown as DocumentNode<SaveSingleConfigurationMutation, SaveSingleConfigurationMutationVariables>;
export const SubscribeFf91Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"subscribeFF91"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"form"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubscribeFF91Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeFF91"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscribeFF91Form"},"value":{"kind":"Variable","name":{"kind":"Name","value":"form"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SubscribeFf91Mutation, SubscribeFf91MutationVariables>;